export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-buttons-4757cb2106c764b3a6d7aeef7a386537.png";